import styled from 'styled-components'

import breakpoints from 'utils/consts/breakpoints'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 32px);
`
export const Header = styled.h5`
  font: var(--typography-14-20-regular);
  color: #717284;
  margin: 0 0 8px;
`

export const AwardsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and ${breakpoints.device.tablet} {
    max-width: calc(100vw - 56px);
  }

  @media screen and ${breakpoints.device.mobile} {
    max-width: calc(100vw - 32px);
  }
`

export const AdditionalInfoColumns = styled.div`
  display: flex;
  gap: 32px;

  @media screen and ${breakpoints.device.mobile} {
    flex-direction: column;
  }
`

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
`
export const InfoWrapper = styled.div`
  flex: 1;
`
export const Info = styled.div`
  font: var(--typography-14-20-normal);
`
export const InfoBold = styled(Info)`
  font: var(--typography-18-24-regular);
`

export const Quotes = styled.span`
  font: var(--typography-24-24-regular);
  font-style: italic;
  letter-spacing: 0.3px;
  color: var(--color-brand-red);
`
export const WineDescription = styled.div`
  font: var(--typography-16-24-regular);
  font-style: italic;
  letter-spacing: 0.3px;
  flex: 1;
  z-index: 2;
  text-align: ${props => props.align};
  margin-left: ${props => (props.align === 'left' ? '32px' : 0)};
  align-self: center;

  ${Quotes}:first-child {
    margin-right: 5px;
  }
  ${Quotes}:last-child {
    margin-left: 5px;
  }
`
